import { CustomRouteRecordRaw } from 'vue-router'

export const workbenchRoutes: CustomRouteRecordRaw = {
  path: 'workbench',
  name: 'workbench',
  component: () => import('@/views/workbench/workbench.vue'),
  meta: {
    title: '工作台',
    icon: 'desktop-outlined',
  },
}
